import {Route} from '@angular/router';
import {RoutingID} from '../sb-routing-enum';
import {DebugVersionComponent} from '../../pages/debug/debug-version/debug-version.component';

export const debug: Route = {
  path: 'debug',
  data: {
    icon: '',
    breadcrumb: '',
    id: RoutingID.debug,
  },
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: RoutingID.debugVersion
    },
    {
      path: 'debug-version',
      component: DebugVersionComponent,
      data: {
        id: RoutingID.debugVersion
      },
    },
  ]
};
